import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { VehiclesService } from '../../vehicles/list-vehicles.service';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { DetailVehicleComponent } from '../../vehicles/detail-vehicle/detail-vehicle.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { ReceivableModificationsDetailComponent } from '../receivable-modifications-detail/receivable-modifications-detail.component';
import { Modification, Receivable } from 'src/app/core/interfaces/receivable';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { ReceivableService } from '../receivable.service';
import { CargoMessages } from 'src/app/core/messages/cargo-messages.enum';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { Fmt } from 'src/app/core/messages/fmt';
import { Utils } from 'src/app/core/resources/utils';
import { CargoDetailService } from 'src/app/modules/cargo/cargo-detail/cargo-detail.service';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { CargoItemService } from 'src/app/modules/cargo/cargo-item/cargo-item.service';
import { TravelExpense } from 'src/app/core/interfaces/travel-expense';
import { TravelExpensesService } from 'src/app/core/services/travel-expenses.service';
import { CargoPaymentsService } from 'src/app/core/services/cargo-payments.service';
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-receivable-detail',
  templateUrl: './receivable-detail.component.html',
  styleUrls: ['./receivable-detail.component.scss'],
  providers: [
    VehiclesService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceivableDetailComponent implements OnInit {
  @Input() receivables;
  @Input() storageInputs;
  @Input() emptyStorage: boolean;
  @Input() resetPagination: boolean;
  @Input() cleanFields: boolean;
  @Output() emitFilters: EventEmitter<any> = new EventEmitter();
  @Output() refreshListReceivable: EventEmitter<boolean> = new EventEmitter();
  vehicle: Vehicle;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  pageSizeOptions: number[] = [2, 5]; // Opciones de tamaño de página
  pageSize: number = this.pageSizeOptions[0];
  pageIndex: number = 0;
  receivablesSlice = [];
  permission = Permission;
  readonly PAYMENT_BY_CARGO = 'cargo';
  readonly PAYMENT_MANUAL = 'manual';
  constructor(
    public vehiclesService: VehiclesService,
    private cargoDetailService: CargoDetailService,
    private cargoItemService: CargoItemService,
    private travelExpensesService: TravelExpensesService,
    public matDialog: MatDialog,
    private spinner: NgxSpinnerService,
    private receivableService: ReceivableService,
    private snackBarService: SnackBarService,
    public permissionRole: PermissionRole,
    public utils: Utils,
    private cargoPaymentsService: CargoPaymentsService
  ) { }

  ngOnInit() {
    this.paginator._intl.itemsPerPageLabel = "Carteras por página";
    if (sessionStorage.getItem('_pageSizeReceivable')) sessionStorage.removeItem('_pageSizeReceivable')
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.receivables && changes.receivables.currentValue) {
      if (this.receivables) {
        if (sessionStorage.getItem('_pageSizeReceivable')) {
          this.receivablesSlice = this.receivables.slice(0, Number(sessionStorage.getItem('_pageSizeReceivable')))
        } else {
          this.receivablesSlice = this.receivables.slice(0, 2);
        }
      }
    }
    if (changes && changes.resetPagination && this.resetPagination !== undefined) {
      this.pageIndex = 0;
    }
  }

  getDetailVehicle(licensePlate: string, type: string, receivable?) {
    if (!this.showVehicleDetail && type === 'detail') return;
    if (!this.showReceivablePayments && type === 'info') return;
    this.spinner.show();
    if (licensePlate) {
      this.vehiclesService.getVehicleFromOwnCompany(licensePlate).subscribe(
        (success: any) => {
          this.spinner.hide();
          if (success) {
            this.vehicle = success;
            if (type === 'detail') this.openDetailVehicle();
            if (type === 'info' && receivable) this.openDetailModifications(receivable);
          } else {
            this.vehicle = null;
          }
        },
        (error) => {
          this.spinner.hide();
          this.vehicle = null;
        }
      );
    }
  }

  openDetailVehicle() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      vehicle: this.vehicle,
      receivable: true,
      close: true,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(DetailVehicleComponent, dialogConfig);
  }

  onPageChange(event: PageEvent) {
    sessionStorage.setItem('_pageSizeReceivable', event.pageSize.toString());
    this.pageIndex = event && (event.pageIndex || event.pageIndex === 0) ? event.pageIndex : this.pageIndex;
    this.pageSize = event && event.pageSize ? event.pageSize : this.pageSize;
    const startIndex = this.pageIndex * this.pageSize;
    let endIndex = startIndex + this.pageSize;
    if (endIndex > this.receivables.length) {
      endIndex = this.receivables.length
    }
    // Actualiza el arreglo 'receivables' con los elementos de la página actual
    this.receivablesSlice = this.receivables.slice(startIndex, endIndex);
  }

  openDetailModifications(receivable: Receivable) {
    if (this.vehicle && this.vehicle.bankAccountBalance && this.vehicle.bankAccountBalance.document) {
      var holder = {
        name: this.vehicle.bankAccountBalance.name,
        document: this.vehicle.bankAccountBalance.document,
        documentTypeName: this.vehicle.bankAccountBalance.documentTypeName
      };
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      receivable: receivable,
      holder: receivable && receivable.debtor ? receivable.debtor : holder
    }
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(ReceivableModificationsDetailComponent, dialogConfig);
  }

  removeReceivable(receivableId: string, receivableConsecutive: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `¿Está seguro que quiere eliminar la cartera #${receivableConsecutive}?`,
      textArea: true,
      description: "Por favor indique la razón por la cual desea eliminar la cartera: "
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state && result.message) {
        const deleteObserver = {
          next: () => {
            this.refreshListReceivable.emit(true);
            this.spinner.hide();
            this.snackBarService.openSnackBar(CargoMessages.SUCCESS_RECEIVABLE_DELETE, undefined, "success");
          },
          error: (error) => {
            this.spinner.hide();
            if (error && error.error && error.error.message) this.snackBarService.openSnackBar(error.error.message, undefined, 'error');
            else this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
          },
          complete: () => {
            this.spinner.hide();
          }
        };
        this.spinner.show();
        let observation = {
          message: result.message
        }
        this.receivableService.deleteReceivable(receivableId, observation).subscribe(deleteObserver);
      }
    });
  }

  async addPaymentReceivable(receivableId: string, receivableConsecutive: string, amountInitial: number, amountReceived: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Registrar abono a cartera #${receivableConsecutive}`,
      description: "Complete la información del abono a registrar:",
      selectorLabel: "Abonar cartera por",
      selectorOptions: [
        {
          label: "ID del servicio",
          value: this.PAYMENT_BY_CARGO,
          description: "El abono se descuenta del saldo pendiente del servicio que indiques."
        },
        {
          label: "Compensación manual",
          value: this.PAYMENT_MANUAL,
          description: "El abono no descuenta de ningún servicio. Requiere una descripción."
        }
      ],
      inputCurrency: true,
      placeholderInputCurrency: "Monto del abono",
      inputText: true,
      placeholder: "Id del servicio",
      minLength: 1,
      inputTextShowOnOption: this.PAYMENT_BY_CARGO,
      inputDescription: true,
      placeholderDescription: "Descripción de la compensación",
      inputDescriptionShowOnOption: this.PAYMENT_MANUAL,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const result = await this.matDialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    if (!result || !result.state) return;
    const remainingBalance = amountInitial - amountReceived;
    if (result.inputCurrency && result.inputCurrency > remainingBalance)
      return this.showErrorReceivableModification(`El monto ingresado supera el saldo restante de la cartera. El saldo pendiente es de ${this.utils.formatCurrency(remainingBalance)}.`);
    // Compensación manual: no descuenta de un servicio, solo se valida contra el saldo de la cartera
    if (result.selectedOption === this.PAYMENT_MANUAL) {
      const manualModification: Modification = { amount: result.inputCurrency, description: result.inputDescription };
      return this.createReceivableModification(receivableId, manualModification, receivableConsecutive);
    }
    let cargo: Cargo;
    this.spinner.show();
    try { cargo = await this.cargoDetailService.detailCargoByConsecutive(result.inputText).toPromise(); } catch (error) { }
    if (!cargo) {
      this.spinner.hide();
      return this.showErrorReceivableModification(`El servicio ${result.inputText} no existe.`);
    }
    const balance = await this.cargoPaymentsService.getBalance(cargo, false);
    this.spinner.hide();
    if ([CargoStateEnum.DELETED, CargoStateEnum.EXPIRED].includes(cargo.state))
      return this.showErrorReceivableModification(`El servicio ${result.inputText} ya fue eliminado o está expirado.`);
    const isPaid = this.utils.getNestedValue(cargo, 'shippingCost.paid');
    const hasBalancePaid = this.utils.getNestedValue(cargo, 'shippingCost.balanceState')
    if (isPaid || hasBalancePaid) return this.showErrorReceivableModification(`El servicio ${result.inputText} ya fue pagado. Reversa el pago para agregar un abono.`);
    if (result.inputCurrency > balance)
      return this.showErrorReceivableModification(`El monto ${this.utils.formatCurrency(result.inputCurrency)} supera el saldo restante del servicio ${result.inputText} (${this.utils.formatCurrency(balance)}).`);
    this.createReceivableModification(receivableId, { amount: result.inputCurrency, cargoConsecutive: Number(result.inputText) }, receivableConsecutive);
  }


  private showErrorReceivableModification(description: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'No es posible registrar el abono',
      iconError: true,
      descriptionHTML: `<p class="text-center mb-0">${description}</p>`,
      hideBtnConfirm: true
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(DialogComponent, dialogConfig);
  }

  private createReceivableModification(receivableId: string, modification: Modification, receivableConsecutive: string) {
    const createReceivableModificationObserver = {
      next: () => {
        this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.SUCCESS_RECEIVABLE_MODIFICATION, `${receivableConsecutive}`), undefined, 'success');
        this.refreshListReceivable.emit(true);
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        const message = error && error.error && error.error.message ? error.error.message : ServiceMessages.GENERAL_HTTP_ERROR;
        this.snackBarService.openSnackBar(message, undefined, 'error');
      }
    }
    this.spinner.show();
    this.receivableService.createReceivableModification(receivableId, modification)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(createReceivableModificationObserver)
  }

  get showVehicleDetail(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.readVehicleDetails);
  };

  get showReceivablePayments(): boolean {
    return this.permissionRole.hasPermission(this.permission.payments.module, this.permission.payments.viewPaymentsReceivables);
  };
}


